var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 48,
    viewBox: "0 0 47 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3.5,
    width: 41,
    height: 41,
    rx: 20.5,
    fill: "#242424",
    stroke: "#F2F2F2",
    strokeWidth: 6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8665_4787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.8874 21.7812C28.2312 18.8937 25.7124 17.5938 23.4999 17.5938C23.4999 17.5938 23.4999 17.5938 23.4937 17.5938C21.2874 17.5938 18.7624 18.8875 18.1062 21.775C17.3749 25 19.3499 27.7312 21.1374 29.45C21.7999 30.0875 22.6499 30.4062 23.4999 30.4062C24.3499 30.4062 25.1999 30.0875 25.8562 29.45C27.6437 27.7312 29.6187 25.0062 28.8874 21.7812ZM23.4999 24.9125C22.4124 24.9125 21.5312 24.0313 21.5312 22.9438C21.5312 21.8563 22.4124 20.975 23.4999 20.975C24.5874 20.975 25.4687 21.8563 25.4687 22.9438C25.4687 24.0313 24.5874 24.9125 23.4999 24.9125Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8665_4787",
    x: 12,
    y: 16.5,
    width: 23,
    height: 23,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0185792 0 0 0 0 0.133088 0 0 0 0 0.03003 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8665_4787"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8665_4787",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartLocation);
export default __webpack_public_path__ + "static/media/cart-location.9c6342de940a333fd807ba4f85b1ce2a.svg";
export { ForwardRef as ReactComponent };